import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const ToolsIcon: React.FC<IconProps> = ({ className = '', size = 64 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2V8H20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9H9H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PackageIcon: React.FC<IconProps> = ({ className = '', size = 64 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 2L3 6.5L12 11L21 6.5L12 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6.5V17.5L12 22L21 17.5V6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2L3 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2L21 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GitHubIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.17 6.839 9.49.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.5.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.167 22 16.418 22 12c0-5.523-4.477-10-10-10z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfoIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="8"
        r="1"
        fill="currentColor"
      />
    </svg>
  );
};

export const CopyIcon: React.FC<IconProps> = ({ className = '', size = 20 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="9"
        y="9"
        width="13"
        height="13"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckIcon: React.FC<IconProps> = ({ className = '', size = 20 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20 6L9 17L4 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PartyPopperIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M39.668 47.588c1.553-1.529.715-5.041-1.822-9.098c.922-.144 1.784-.364 2.436-.701c2.346-1.211 3.93-3.418 5.129-5.701c1.289-2.449 2.154-5.141 3.836-7.371c.284-.377.568-.715.851-1.033c3.629.435 6.526 1.215 6.526 1.215l1.107-2.813a29.917 29.917 0 0 0-4.286-1.187c.892-.507 1.474-.665 1.474-.665l-1.049-2.836c-1.682.711-3.047 1.76-4.19 3.016c-4.272-.239-8.574.612-11.968 3.244c-2.552 1.98-4.276 4.725-5.898 7.471a44.86 44.86 0 0 0-4.581-3.927c.306-.503.634-.955.987-1.304c2.133-2.1 4.947-3.443 6.793-5.846c3.88-5.046 1.042-12.956-2.15-17.052c-.572.551-1.518 1.354-2.23 1.988c3.393 3.475 5.766 9.559 3.107 14.105c-1.486 2.541-4.232 4.135-6.152 6.318c-.332.379-.629.859-.898 1.389c-5.021-3.601-9.629-5.05-11.455-3.252a2.35 2.35 0 0 0-.442.634l-.007-.007l-.049.143c-.068.155-.13.316-.172.492L2 61l36.662-12.818l-.01-.01c.394-.127.741-.314 1.016-.584M9.293 56.332l-3.06-1.426l2.065-5.95l9.471 4.412l-8.476 2.964m16.951-5.927l-15.879-7.399l2.065-5.949l11.866 5.956c-7.083-4.61-9.801-11.907-9.801-11.907l.706-2.033c1.255 3.175 4.016 7.129 7.81 10.861c3.826 3.766 7.881 6.494 11.122 7.713l-7.889 2.758m6.099-18.74c1.658-2.377 3.367-4.776 5.743-6.483c2.262-1.626 5.934-1.923 9.415-1.728c-1.176 2.054-2.045 4.333-2.825 6.522c-.943 2.65-2.207 5.398-4.617 7.023c-.65.438-1.561.758-2.534.995c-1.337-2.049-3.091-4.215-5.182-6.329"
        fill="currentColor"
      />
      <path
        d="M23.033 22c1.002 0-2.002-3-1.5-5.631c1.924-.148 6.322.719 3.762-2.797c2.896.51 4.396-1.652 1.662-3.701c.91.064 2.324-1.652 1.309-1.869c-3.252-.689-4.525 1.07-2.461 3.607c-2.17-.404-3.939.605-2.309 2.871c-6.266-.781-2.701 7.52-.463 7.52"
        fill="currentColor"
      />
      <path
        d="M44.545 19.334c.939-.424-.654-3.225-1.172-3.941c3.963-.424 3.813-1.605 1.328-4.135c6.756.227.209-3.613 1.127-5.133c.795-1.318 3.234.064 3.008-.67c-.762-2.455-7.99-.795-3.416 3.789c-3.992.078-4.375 1.383-1.4 4.088c-5.182.057-.954 6.668.525 6.002"
        fill="currentColor"
      />
      <path
        d="M61.697 29.225c-1.582.443-1.826.277-1.615 1.852c-3.654-1.682-7.52-4.021-5.174 2.176c-4.15-2.471-3.943-.307-4.719 3.254c-1.01-.787-2.445-2.861-2.445-2.861l-1.52 1.291s2.785 3.928 4.16 3.705c1.209-.195 1.867-2.48 1.934-4.494c3.85 1.625 5.693 1.842 3.932-2.91c3.078 1.729 6.852 3.254 5.447-2.013"
        fill="currentColor"
      />
      <path d="M6.049 11.437l2.828 2.829l-2.828 2.828l-2.829-2.828z" fill="currentColor" />
      <path d="M12.824 23.198l-2.83 2.828l-2.829-2.83l2.83-2.829z" fill="currentColor" />
      <path d="M17.22 7l2.828 2.828l-2.829 2.83l-2.828-2.83z" fill="currentColor" />
      <path d="M48.011 46.484l-2.83-2.829l2.828-2.83l2.83 2.829z" fill="currentColor" />
      <path d="M41.705 56.186l-2.828-2.828l2.828-2.829l2.829 2.829z" fill="currentColor" />
      <path d="M54.113 58.42l-2.83-2.829l2.827-2.83l2.83 2.829z" fill="currentColor" />
      <path d="M56.941 45.536l-2.828-2.829l2.828-2.828l2.828 2.828z" fill="currentColor" />
      <path d="M52.22 10l2.828 2.828l-2.829 2.829l-2.828-2.829z" fill="currentColor" />
    </svg>
  );
};

